export default {
    state: {
        languages: [],
        language: {}
    },
    mutations: {
        SET_DEFAULT_LANGUAGE(state, payload) {
            state.language = payload
        }
    },
    getters: {
        LANGUAGE(state) {
            return state.language
        }
    }
}